import React from "react";
import { Link } from "react-router-dom";
import "../apiProductAdvantages/apiProductAdvantages.css";

// One card per API, opening its documentation in a new tab. Used by the Advantages section and,
// for products without one, by ApiProductApis.
const ApiDocumentationCards = ({ apis }) => (
  <div className="api-documentation-grid">
    {apis.map((api) => {
      // Use alias which already contains the full path like "/documentation/Account-Information-Berlin-Group-v1"
      const targetUrl =
        api.alias || `/documentation/${api.title || api.name || ""}`;

      return (
        <Link
          key={api.uuid || api.title}
          to={targetUrl}
          target="_blank"
          className="api-documentation-card"
        >
          <div className="api-card-content">
            <span className="api-card-icon icon-icon_open" />
            <span className="api-card-title">{api.title}</span>
          </div>
        </Link>
      );
    })}
  </div>
);

export default ApiDocumentationCards;
